import type { QueryClient } from "@tanstack/react-query";
import { transformProjectArray } from "hooks/useProjects/projectTransform";
import {
  readCachedProjectDetail,
  unwrapProjectApiPayload,
} from "hooks/useProjects/projectDetailQuery";
import type { ProjectPayload } from "hooks/useProjects/useProjects.types";
import type { ProjectState } from "hooks/useProjects/useProjects.types";

/**
 * When the detail query observer has not produced transformed data yet, hydrate from the
 * canonical React Query cache entry (same payload as GET /projects/:id).
 */
export const hydrateProjectFromDetailCache = (
  queryClient: QueryClient,
  projectId: string,
  project: ProjectState | null | undefined
): ProjectState | null => {
  if (project) {
    return project;
  }
  if (!projectId) {
    return null;
  }
  const cached = readCachedProjectDetail(queryClient, projectId);
  if (!cached) {
    return null;
  }
  const payload = unwrapProjectApiPayload<ProjectPayload>(cached);
  return transformProjectArray([payload])[0] ?? null;
};
